import { bchUtils, btcUtils, zecUtils } from "./chains";
import { Ox, strip0x } from "./common";
import { randomNonce } from "./renVMUtils";
import { value } from "./value";
export const utils = {
    Ox,
    strip0x,
    randomNonce,
    value,
    // Bitcoin
    BTC: btcUtils,
    btc: btcUtils,
    // Zcash
    ZEC: zecUtils,
    zec: zecUtils,
    // Bitcoin Cash
    BCH: bchUtils,
    bch: bchUtils,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsRUFBRSxRQUFRLEVBQUUsUUFBUSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBQ3hELE9BQU8sRUFBRSxFQUFFLEVBQUUsT0FBTyxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxXQUFXLEVBQUUsTUFBTSxjQUFjLENBQUM7QUFDM0MsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUVoQyxNQUFNLENBQUMsTUFBTSxLQUFLLEdBQUc7SUFDakIsRUFBRTtJQUNGLE9BQU87SUFDUCxXQUFXO0lBQ1gsS0FBSztJQUVMLFVBQVU7SUFDVixHQUFHLEVBQUUsUUFBUTtJQUNiLEdBQUcsRUFBRSxRQUFRO0lBRWIsUUFBUTtJQUNSLEdBQUcsRUFBRSxRQUFRO0lBQ2IsR0FBRyxFQUFFLFFBQVE7SUFFYixlQUFlO0lBQ2YsR0FBRyxFQUFFLFFBQVE7SUFDYixHQUFHLEVBQUUsUUFBUTtDQUNoQixDQUFDIn0=